export const TURNSTILE_LOGIN_ACTION = "auth_login"
export const TURNSTILE_INVITE_ACTION = "auth_invite"

export function isTurnstileRequired() {
  const configuredValue = import.meta.env.VITE_TURNSTILE_ENABLED?.trim().toLowerCase()

  if (configuredValue === "true") return true
  if (configuredValue === "false") return false

  return import.meta.env.PROD
}

export function getTurnstileSiteKey() {
  return import.meta.env.VITE_TURNSTILE_SITE_KEY?.trim() ?? ""
}
